module.exports = __webpack_public_path__ + "static/17-e96990bd9f9fa1747df7eb39dac201d1.png";